import { CbCarousel, CbCarouselItem } from '@chubb/ui-components/cb-carousel';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingModalComponent } from './loading-modal.component';
import { EmailFormModule } from '../email-form/email-form.module';
import { MatDialogModule } from '@angular/material/dialog';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CarouselModule } from 'primeng/carousel';
@NgModule({
    declarations: [LoadingModalComponent],
    imports: [
        CommonModule,
        EmailFormModule,
        MatDialogModule,
        AppAnalyticsModule,
        MatProgressBarModule,
        CarouselModule,
        CbCarousel,
        CbCarouselItem,
    ],
    exports: [LoadingModalComponent],
})
export class LoadingModalModule {}
